import { render, staticRenderFns } from "./AjaxTable.vue?vue&type=template&id=34985b87&scoped=true&"
import script from "./AjaxTable.vue?vue&type=script&lang=js&"
export * from "./AjaxTable.vue?vue&type=script&lang=js&"
import style0 from "./AjaxTable.vue?vue&type=style&index=0&id=34985b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34985b87",
  null
  
)

export default component.exports